"use client";

import { c as _c } from "react/compiler-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";
import { Button, cn, Form, FormControl, FormField, FormItem, FormLabel, FormMessage, Input, Textarea } from "@saridana-core/react-ui-kit";
import { buildFormSchema } from "@shared/lib/form";
import { TFormField } from "@shared/types";
export function DynamicForm(t0) {
  const $ = _c(25);
  const {
    fields,
    defaultValues,
    children,
    onSubmit
  } = t0;
  let t1;
  let t2;
  if ($[0] !== fields) {
    const formSchema = buildFormSchema(fields);
    t2 = useForm;
    t1 = zodResolver(formSchema);
    $[0] = fields;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== defaultValues || $[4] !== t1) {
    t3 = {
      resolver: t1,
      defaultValues
    };
    $[3] = defaultValues;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const form = t2(t3);
  let t4;
  if ($[6] !== form) {
    t4 = (field, f) => {
      if (f.inputType === "textarea") {
        return <Textarea rows={3} className="!p-4 text-lg md:!text-xl" placeholder={f.placeholder} {...field} value={field.value as string} />;
      }
      if (f.inputType === "radio" && f.options && f.options.length > 0) {
        return <div className="w-full rounded-full flex items-center bg-gray-200 overflow-hidden">{f.options?.map((option, index) => <Button key={`form-field-${f.id}-option-${index}`} type="button" variant="outline" onClick={() => {
            form.resetField(f.name, {
              defaultValue: option
            });
          }} className={cn("m-1 rounded-full text-md h-11 w-full font-semibold", field.value === option ? "border border-primary" : "border-none shadow-none bg-transparent")}><span className={cn(field.value == option ? "text-primary" : "text-gray-600")}>{option}</span></Button>)}</div>;
      }
      return <Input className="!p-4 min-h-[50px] md:min-h-[60px] text-lg md:!text-xl" type={f.inputType} placeholder={f.placeholder} {...field} value={field.value as string} />;
    };
    $[6] = form;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const getFormInput = t4;
  let t5;
  if ($[8] !== form || $[9] !== onSubmit) {
    t5 = form.handleSubmit(onSubmit);
    $[8] = form;
    $[9] = onSubmit;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== fields || $[12] !== form.control || $[13] !== getFormInput) {
    let t7;
    if ($[15] !== form.control || $[16] !== getFormInput) {
      t7 = f_0 => {
        const name = f_0.name;
        return <FormField key={name} control={form.control} name={name} render={t8 => {
          const {
            field: field_0
          } = t8;
          return <FormItem>{f_0.label && <FormLabel className="text-base md:text-lg mb-2 inline-block">{f_0.label}</FormLabel>}<FormControl>{getFormInput(field_0, f_0)}</FormControl><FormMessage className="text-sm md:text-base inline-block mt-2" /></FormItem>;
        }} />;
      };
      $[15] = form.control;
      $[16] = getFormInput;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    t6 = fields.map(t7);
    $[11] = fields;
    $[12] = form.control;
    $[13] = getFormInput;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[18] !== children || $[19] !== t5 || $[20] !== t6) {
    t7 = <form onSubmit={t5} className="space-y-6">{t6}{children}</form>;
    $[18] = children;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== form || $[23] !== t7) {
    t8 = <Form {...form}>{t7}</Form>;
    $[22] = form;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}